import { assetUrl } from '@Shared/Helpers/Utilities';

export const MEDALS = [
    {
        alt: 'Referral Factory Fastest Implementation',
        img: assetUrl('/assets/images/webp/web/medals/medal_1.webp'),
        imgLow: assetUrl('/assets/images/webp/web/medals/medal_1-low.webp'),
    },
    {
        alt: 'iso',
        img: assetUrl('/assets/images/webp/web/medals/medal_15.webp'),
        imgLow: assetUrl('/assets/images/webp/web/medals/medal_15-low.webp'),
        hideOnFooter: true,
    },
    {
        alt: 'Referral Factory Easiest To use',
        img: assetUrl('/assets/images/webp/web/medals/medal_2.webp'),
        imgLow: assetUrl('/assets/images/webp/web/medals/medal_2-low.webp'),
    },
    {
        alt: 'Referral Factory Leader',
        img: assetUrl('/assets/images/webp/web/medals/medal_3.webp'),
        imgLow: assetUrl('/assets/images/webp/web/medals/medal_3-low.webp'),
    },
    {
        alt: 'soc2',
        img: assetUrl('/assets/images/webp/web/medals/medal_14.webp'),
        imgLow: assetUrl('/assets/images/webp/web/medals/medal_14-low.webp'),
        hideOnFooter: true,
    },
    {
        alt: 'Referral Factory Momentum Leader',
        img: assetUrl('/assets/images/webp/web/medals/medal_4.webp'),
        imgLow: assetUrl('/assets/images/webp/web/medals/medal_4-low.webp'),
    },
    {
        alt: 'Referral Factory Users Love Us',
        img: assetUrl('/assets/images/webp/web/medals/medal_5.webp'),
        imgLow: assetUrl('/assets/images/webp/web/medals/medal_5-low.webp'),
    },
    {
        alt: 'Referral Factory High Performer',
        img: assetUrl('/assets/images/webp/web/medals/medal_6.webp'),
        imgLow: assetUrl('/assets/images/webp/web/medals/medal_6-low.webp'),
    },
    {
        alt: 'Referral Factory Leader',
        img: assetUrl('/assets/images/webp/web/medals/medal_7.webp'),
        imgLow: assetUrl('/assets/images/webp/web/medals/medal_7-low.webp'),
    },
    {
        alt: 'Referral Factory Shortlist',
        img: assetUrl('/assets/images/webp/web/medals/medal_8.webp'),
        imgLow: assetUrl('/assets/images/webp/web/medals/medal_8-low.webp'),
    },
    {
        alt: 'Referral Factory Beast Ease Of Use',
        img: assetUrl('/assets/images/webp/web/medals/medal_9.webp'),
        imgLow: assetUrl('/assets/images/webp/web/medals/medal_9-low.webp'),
    },
    {
        alt: 'Referral Factory Leaders',
        img: assetUrl('/assets/images/webp/web/medals/medal_10.webp'),
        imgLow: assetUrl('/assets/images/webp/web/medals/medal_10-low.webp'),
    },
    {
        alt: 'Referral Factory Best Functionality & Features',
        img: assetUrl('/assets/images/webp/web/medals/medal_11.webp'),
        imgLow: assetUrl('/assets/images/webp/web/medals/medal_11-low.webp'),
    },
    {
        alt: 'Referral Factory Most Recommended',
        img: assetUrl('/assets/images/webp/web/medals/medal_12.webp'),
        imgLow: assetUrl('/assets/images/webp/web/medals/medal_12-low.webp'),
    },
    {
        alt: 'Referral Factory Best Customer Support',
        img: assetUrl('/assets/images/webp/web/medals/medal_13.webp'),
        imgLow: assetUrl('/assets/images/webp/web/medals/medal_13-low.webp'),
    },
];

export const SECURITY_MEDALS = [
    {
        alt: 'iso',
        img: assetUrl('/assets/images/webp/web/medals/medal_15.webp'),
        imgLow: assetUrl('/assets/images/webp/web/medals/medal_15-low.webp'),
    },
    {
        alt: 'soc2',
        img: assetUrl('/assets/images/webp/web/medals/medal_14.webp'),
        imgLow: assetUrl('/assets/images/webp/web/medals/medal_14-low.webp'),
    },
];

export const INTEGRATIONS = [
    'api',
    'webhook',
    'hubspot',
    'stripe',
    'intercom',
    'zapier',
    'zoho',
    'pipedrive',
    'serviceTitan',
    'monday',
    'salesforce',
];

export const ROI = [
    {
        value: 'financial',
        header: 'Financial Services',
        img1: assetUrl('/assets/images/webp/web/campaigns/financial-1.webp'),
        img2: assetUrl('/assets/images/webp/web/campaigns/financial-2.webp'),
        img1Low: assetUrl('/assets/images/webp/web/campaigns/financial-1-low.webp'),
        img2Low: assetUrl('/assets/images/webp/web/campaigns/financial-2-low.webp'),
        alt: 'Financial services referral program',
    },
    {
        value: 'solar',
        header: 'Solar',
        img1: assetUrl('/assets/images/webp/web/campaigns/solar-1.webp'),
        img2: assetUrl('/assets/images/webp/web/campaigns/solar-2.webp'),
        img1Low: assetUrl('/assets/images/webp/web/campaigns/solar-1-low.webp'),
        img2Low: assetUrl('/assets/images/webp/web/campaigns/solar-2-low.webp'),
        alt: 'Solar referral program',
    },
    {
        value: 'education',
        header: 'Education',
        img1: assetUrl('/assets/images/webp/web/campaigns/education-1.webp'),
        img2: assetUrl('/assets/images/webp/web/campaigns/education-2.webp'),
        img1Low: assetUrl('/assets/images/webp/web/campaigns/education-1-low.webp'),
        img2Low: assetUrl('/assets/images/webp/web/campaigns/education-2-low.webp'),
        alt: 'Education referral program',
    },
    {
        value: 'saas',
        header: 'SaaS',
        img1: assetUrl('/assets/images/webp/web/campaigns/saas-1.webp'),
        img2: assetUrl('/assets/images/webp/web/campaigns/saas-2.webp'),
        img1Low: assetUrl('/assets/images/webp/web/campaigns/saas-1-low.webp'),
        img2Low: assetUrl('/assets/images/webp/web/campaigns/saas-2-low.webp'),
        alt: 'saas referral program',
    },
    {
        value: 'banking',
        header: 'Banking',
        img1: assetUrl('/assets/images/webp/web/campaigns/banking-1.webp'),
        img2: assetUrl('/assets/images/webp/web/campaigns/banking-2.webp'),
        img1Low: assetUrl('/assets/images/webp/web/campaigns/banking-1-low.webp'),
        img2Low: assetUrl('/assets/images/webp/web/campaigns/banking-2-low.webp'),
        alt: 'Banking referral program',
    },
];

export const ROI_STATS = {
    financial: [
        {
            img: assetUrl('/assets/images/svg/web/user-check.svg'),
            title: __('New customers in 6 months'),
            stats: '1879',
        },
        {
            img: assetUrl('/assets/images/svg/web/roi.svg'),
            title: __('ROI in 6 months'),
            stats: '120x',
        },
        {
            img: assetUrl('/assets/images/svg/web/arrow-down-blue.svg'),
            title: __('Cost Per Lead'),
            stats: '-27%',
        },
    ],
    solar: [
        {
            img: assetUrl('/assets/images/svg/web/user-check.svg'),
            title: __('New customers in 6 months'),
            stats: '270',
        },
        {
            img: assetUrl('/assets/images/svg/web/roi.svg'),
            title: __('ROI in 6 months'),
            stats: '59x',
        },
        {
            img: assetUrl('/assets/images/svg/web/arrow-down-blue.svg'),
            title: __('Cost Per Lead'),
            stats: '-42%',
        },
    ],
    education: [
        {
            img: assetUrl('/assets/images/svg/web/user-check.svg'),
            title: __('New customers in 6 months'),
            stats: '111',
        },
        {
            img: assetUrl('/assets/images/svg/web/roi.svg'),
            title: __('ROI in 6 months'),
            stats: '23x',
        },
        {
            img: assetUrl('/assets/images/svg/web/arrow-down-blue.svg'),
            title: __('Cost Per Lead'),
            stats: '-39%',
        },
    ],
    saas: [
        {
            img: assetUrl('/assets/images/svg/web/user-check.svg'),
            title: __('New customers in 6 months'),
            stats: '350',
        },
        {
            img: assetUrl('/assets/images/svg/web/roi.svg'),
            title: __('ROI in 6 months'),
            stats: '54x',
        },
        {
            img: assetUrl('/assets/images/svg/web/arrow-down-blue.svg'),
            title: __('Cost Per Lead'),
            stats: '-32%',
        },
    ],
    banking: [
        {
            img: assetUrl('/assets/images/svg/web/user-check.svg'),
            title: __('New customers in 6 months'),
            stats: '1303',
        },
        {
            img: assetUrl('/assets/images/svg/web/roi.svg'),
            title: __('ROI in 6 months'),
            stats: '300x',
        },
        {
            img: assetUrl('/assets/images/svg/web/arrow-down-blue.svg'),
            title: __('Cost Per Lead'),
            stats: '-45%',
        },
    ],
};

export const FLAGS = [
    {
        alt: 'Referral-Marketing-Software-Arabic',
        img: assetUrl('/assets/images/svg/web/flags/Referral-Marketing-Software-Arabic.svg'),
    },
    {
        alt: 'Referral-Marketing-Software-Armenian',
        img: assetUrl(
            '/assets/images/svg/web/flags/Referral-Marketing-Software-Armenian.svg'
        ),
    },
    {
        alt: 'Referral-Marketing-Software-Bangla',
        img: assetUrl('/assets/images/svg/web/flags/Referral-Marketing-Software-Bangla.svg'),
    },
    {
        alt: 'Referral-Marketing-Software-Chinese',
        img: assetUrl('/assets/images/svg/web/flags/Referral-Marketing-Software-Chinese.svg'),
    },
    {
        alt: 'Referral-Marketing-Software-Dutch',
        img: assetUrl('/assets/images/svg/web/flags/Referral-Marketing-Software-Dutch.svg'),
    },
    {
        alt: 'Referral-Marketing-Software-English',
        img: assetUrl('/assets/images/svg/web/flags/Referral-Marketing-Software-English.svg'),
    },
    {
        alt: 'Referral-Marketing-Software-Finnish',
        img: assetUrl('/assets/images/svg/web/flags/Referral-Marketing-Software-Finnish.svg'),
    },
    {
        alt: 'Referral-Marketing-Software-French',
        img: assetUrl('/assets/images/svg/web/flags/Referral-Marketing-Software-French.svg'),
    },
    {
        alt: 'Referral-Marketing-Software-German',
        img: assetUrl('/assets/images/svg/web/flags/Referral-Marketing-Software-German.svg'),
    },
    {
        alt: 'Referral-Marketing-Software-Greece',
        img: assetUrl('/assets/images/svg/web/flags/Referral-Marketing-Software-Greece.svg'),
    },
    {
        alt: 'Referral-Marketing-Software-Hindi',
        img: assetUrl('/assets/images/svg/web/flags/Referral-Marketing-Software-Hindi.svg'),
    },
    {
        alt: 'Referral-Marketing-Software-Hungarian',
        img: assetUrl(
            '/assets/images/svg/web/flags/Referral-Marketing-Software-Hungarian.svg'
        ),
    },
    {
        alt: 'Referral-Marketing-Software-Italian',
        img: assetUrl('/assets/images/svg/web/flags/Referral-Marketing-Software-Italian.svg'),
    },
    {
        alt: 'Referral-Marketing-Software-Japanese',
        img: assetUrl(
            '/assets/images/svg/web/flags/Referral-Marketing-Software-Japanese.svg'
        ),
    },
    {
        alt: 'Referral-Marketing-Software-Malay',
        img: assetUrl('/assets/images/svg/web/flags/Referral-Marketing-Software-Malay.svg'),
    },
    {
        alt: 'Referral-Marketing-Software-Polish',
        img: assetUrl('/assets/images/svg/web/flags/Referral-Marketing-Software-Polish.svg'),
    },
    {
        alt: 'Referral-Marketing-Software-Portuguese',
        img: assetUrl(
            '/assets/images/svg/web/flags/Referral-Marketing-Software-Portuguese.svg'
        ),
    },
    {
        alt: 'Referral-Marketing-Software-Russian',
        img: assetUrl('/assets/images/svg/web/flags/Referral-Marketing-Software-Russian.svg'),
    },
    {
        alt: 'Referral-Marketing-Software-Spanish',
        img: assetUrl('/assets/images/svg/web/flags/Referral-Marketing-Software-Spanish.svg'),
    },
    {
        alt: 'Referral-Marketing-Software-Swedish',
        img: assetUrl('/assets/images/svg/web/flags/Referral-Marketing-Software-Swedish.svg'),
    },
    {
        alt: 'Referral-Marketing-Software-Ukraine',
        img: assetUrl('/assets/images/svg/web/flags/Referral-Marketing-Software-Ukraine.svg'),
    },
];

export const REVIEWS = [
    {
        alt: 'Ryan Review',
        img: assetUrl('/assets/images/png/web/review/ryan.png'),
        name: 'Ryan',
        info: __('Head of projects'),
        company: __('@ Reeves Independent'),
        text: __(
            "Using Referral Factory we managed to get more people signing up for pension reviews than any other marketing channel (or other tools) we've tried!"
        ),
    },
    {
        alt: ' Joslin Review',
        img: assetUrl('/assets/images/png/web/review/joslin.png'),
        name: 'Joslin',
        info: __('Founder'),
        company: __('@ Eagle Education'),
        text: __(
            'The Stripe integration that comes with this referral software are gold. I didn’t even think it was possible to automate so much without coding!'
        ),
    },
    {
        alt: 'Steve Review',
        img: assetUrl('/assets/images/png/web/review/steve.png'),
        name: 'Steve',
        info: __('Marketing Director'),
        company: __('@ MVSN TV'),
        text: __(
            "The company's customer support, the simplicity to set up a referral campaign, the time to deploy, and just how cool it looks, won the day. "
        ),
    },
    {
        alt: 'Sarah Review',
        img: assetUrl('/assets/images/png/web/review/sarah.png'),
        name: 'Sarah',
        info: __('CEO'),
        company: __('@ Push Media'),
        text: __(
            'By far the most powerful referral software we looked at. Everything you need + stellar support. We started getting referrals after a week!'
        ),
    },
];

export const PRICING = [
    {
        theme: 'light',
        name: __('Starter'),
        monthly: {
            price: '$95',
            label: '',
        },
        yearly: {
            price: '$76',
            label: __('$912 annually'),
        },
        button: {
            text: __('Start free trial'),
            link: 'customer.auth.register',
        },
        users: '500',
        campaigns: __('1 live referral program'),
        features: '',
        extraFeatures: [
            __('Basic rewards'),
            __('Integrations'),
            __('Templates'),
            __('Fraud alerts'),
            __('ReCaptcha verification'),
        ],
    },
    {
        theme: 'light',
        name: __('Basic'),
        monthly: {
            price: '$200',
            label: '',
        },
        yearly: {
            price: '$160',
            label: __('$1920 annually'),
        },
        button: {
            text: __('Start free trial'),
            link: 'customer.auth.register',
        },
        users: '20,000',
        campaigns: __('Unlimited referral programs'),
        features: __('Everything in Starter, plus'),
        extraFeatures: [
            __('Teammate access'),
            __('Video call support'),
            __('Webhooks & API'),
            __('Referral analytics'),
            __('Rewards and payouts'),
        ],
    },
    {
        theme: 'dark',
        name: __('Pro'),
        monthly: {
            price: '$400',
            label: '',
        },
        yearly: {
            price: '$320',
            label: __('$3840 annually'),
        },
        button: {
            text: __('Get a demo'),
            link: 'web.pages.demo',
        },
        users: '40,000',
        campaigns: __('Unlimited referral programs'),
        features: __('Everything in Basic, plus'),
        extraFeatures: [
            __('User verification'),
            __('100% white label'),
            __('Add your own domain'),
            __('2FA secure account'),
            __('Dedicated support'),
        ],
    },
    {
        theme: 'light',
        name: __('Enterprise'),
        monthly: {
            price: '$1000',
            label: 'Starting price.',
        },
        yearly: {
            price: '$800',
            label: 'Starting at $9600 annually',
        },
        button: {
            text: __('Get a demo'),
            link: 'web.pages.demo',
        },
        users: '100,000+',
        campaigns: __('Unlimited referral programs'),
        features: __('Everything in Pro, plus'),
        extraFeatures: [
            __('Upload your own HTML'),
            __('Pay by Invoice'),
            __('Enable SSO'),
            __('Host your own data :ownDataPrice'),
        ],
    },
];

export const TRUSTED_BUSINESSES = [
    {
        img: 'jet',
        alt: 'Jet Learn',
    },
    {
        img: 'easybank',
        alt: 'Easy Bank',
    },
    {
        img: 'nationwide',
        alt: 'Nationwide',
    },
    {
        img: 'volvo',
        alt: 'Volvo',
    },
    {
        img: 'meltwater',
        alt: 'Meltwater',
    },
    {
        img: 'radius',
        alt: 'Radius',
    },
    {
        img: 'liberty',
        alt: 'Liberty',
    },
    {
        img: 'xed',
        alt: 'XED',
    },
    {
        img: 'userlytics',
        alt: 'Userlytics',
    },
    {
        img: 'freshworks',
        alt: 'Freshworks',
    },
    {
        img: 'moneyman',
        alt: 'UK Moneyman',
    },
    {
        img: 'dribbble',
        alt: 'Dribbble',
    },
    {
        img: 'goodegg',
        alt: 'Good Egg',
    },
    {
        img: 'checkatrade',
        alt: 'Checkatrade',
    },
    {
        img: 'bawag',
        alt: 'BAWAG',
    },
    {
        img: 'wagepoint',
        alt: 'Wagepoint',
    },
];
